import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from './storage.service';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../constants/environment';
import { Language } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(
    private translate: TranslateService,
    private storage: StorageService
  ) {
    this.initializeLanguage();
  }

  private initializeLanguage(): void {
    this.translate.addLangs([...SUPPORTED_LANGUAGES]);
    this.translate.setDefaultLang(DEFAULT_LANGUAGE);

    const savedLanguage = this.storage.getLanguage();

    if (savedLanguage && SUPPORTED_LANGUAGES.includes(savedLanguage as any)) {
      this.translate.use(savedLanguage);
    } else {
      const browserLang = this.translate.getBrowserLang();
      const langToUse = browserLang && SUPPORTED_LANGUAGES.includes(browserLang as any)
        ? browserLang
        : DEFAULT_LANGUAGE;
      this.setLanguage(langToUse);
    }
  }

  setLanguage(lang: string): void {
    if (SUPPORTED_LANGUAGES.includes(lang as any)) {
      this.translate.use(lang);
      this.storage.setLanguage(lang);
    }
  }

  getCurrentLanguage(): string {
    return this.translate.currentLang || DEFAULT_LANGUAGE;
  }

  getAvailableLanguages(): readonly string[] {
    return SUPPORTED_LANGUAGES;
  }

   public getTextOnLanguages(languages: Language[]) {
    if (languages == null) {
      return '/!\\ Translation error, null';
    }

    const lang = this.translate.getCurrentLang();
    for (const element of languages) {
      if (element.code == lang) {
        if (element.pivot.data != null) {
          return element.pivot.data;
        } else {
          return '-';
        }
      }
    }
    return '/!\\ Translation error';
  }
}
